import { render, staticRenderFns } from "./EspecialidadesView.vue?vue&type=template&id=cafeb148"
import script from "./EspecialidadesView.vue?vue&type=script&lang=js"
export * from "./EspecialidadesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports